module.exports = __webpack_public_path__ + "static/media/mai-top-bg-video.03fbd068.mp4";